/** Public site identity for Daily Sports Life (dailysportslife.com) */

import {
  getCanonicalSiteOrigin,
  VERCEL_PRODUCTION_ORIGIN,
} from '../utils/canonicalOrigin';

export const SITE_NAME = 'Daily Sports Life';
export const SITE_TAGLINE = 'Sports, training, wellness, and community stories';
export const SITE_DEFAULT_DESCRIPTION =
  'Sports apps, training plans, wellness guides, and community stories from Daily Sports Life.';

/** Default Open Graph / WhatsApp share image (general sports + Daily Sports Life branding). */
export const SITE_DEFAULT_OG_IMAGE_PATH = '/og-daily-sports-life.jpg';

export function getSiteOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return getCanonicalSiteOrigin();
}

export function getDefaultOgImageUrl() {
  return `${getCanonicalSiteOrigin()}${SITE_DEFAULT_OG_IMAGE_PATH}`;
}

/** @deprecated Prefer getDefaultOgImageUrl() for absolute URLs */
export const SITE_DEFAULT_OG_IMAGE = `${VERCEL_PRODUCTION_ORIGIN}${SITE_DEFAULT_OG_IMAGE_PATH}`;

/** Product apps under the Daily Sports Life portal */
export const SITE_APPS = {
  soccer: {
    id: 'soccer',
    name: 'Soccer',
    shortLabel: 'Soccer',
    description: 'Clubs, practices, and balanced team splits for pickup games.',
    href: '/soccer',
  },
  running: {
    id: 'running',
    name: 'Running',
    shortLabel: 'Running',
    description: 'Running clubs with published routes, group practices, availability votes, and photo sharing.',
    href: '/running',
  },
  hiking: {
    id: 'hiking',
    name: 'Hiking',
    shortLabel: 'Hiking',
    description:
      'Hiking clubs with published trails, group outings, availability votes, and photo sharing.',
    href: '/hiking',
  },
  training: {
    id: 'training',
    name: 'Training',
    shortLabel: 'Training',
    description:
      'Sport-specific training plans for soccer and running, with daily logging for soccer.',
    href: '/training',
  },
  blog: {
    id: 'blog',
    name: 'Blog',
    shortLabel: 'Blog',
    description: 'Stories, tips, and updates from Daily Sports Life.',
    href: '/blog',
  },
};

export function formatAppTitle(appName) {
  if (!appName) return SITE_NAME;
  return `${appName} · ${SITE_NAME}`;
}
